import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import "./index.css"
import { NotificationDropDownIcon } from "../../../Data/notifications"
const CustomSelect = ({
    label = 'Select',
    options = [],
    value,
    onChange,
    placeholder = `Select ${label.toLowerCase()}`,
    name,
    disabled = false
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [internalValue, setInternalValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [selectVal, setIsSelectVal] = useState(null)
    const dropdownRef = useRef(null);

    const selected = value !== undefined ? value : internalValue;
    const selectedLabel = options.find(opt => opt.value === selected)?.label || '';

    // Close on outside click
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
                setIsFocused(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (val) => {
        if (onChange) {
            onChange(val);
        } else {
            setInternalValue(val);
        }
        setIsSelectVal(val)
        setIsOpen(false);
        setIsFocused(false);
    };

    return (
        <div className="relative sm:w-[338px] w-full" ref={dropdownRef}>
            {/* Label */}
            <label
                htmlFor={name}
                className={`absolute left-3 px-1 bg-white transition-all duration-200 z-10 ${(isFocused && selectVal) || (selected)
                    ? 'label-above'
                    : 'label-in-place'
                    } pointer-events-none`}
            >
                {placeholder}
            </label>

            {/* Trigger */}
            <div
                onClick={() => {
                    setIsOpen(!isOpen);
                    setIsFocused(true);
                }}
                className={`cursor-pointer w-full border rounded-md px-4 ${selected ? 'pb-1' : 'pb-6'} pt-6 text-sm bg-white text-[#030F23]  ${disabled ? 'opacity-50 pointer-events-none' : ''} ${isFocused ? 'border-[#12ABBF]' : 'border-[#E6E7E9]'
                    }`}
            >
                {selectedLabel || ''}
                <div className="chevron-direction">
                    {isOpen ? <ChevronUp size={20} color="#12ABBF" /> : <ChevronDown size={18} color="#2D3643" />}
                </div>
            </div>

            {/* Dropdown */}
            {isOpen && (
                <div className="list-dropDown">
                    {options.map((opt) => {

                        const Icon = NotificationDropDownIcon[opt.value];

                        return (
                            <div
                                key={opt.value}
                                onClick={() => handleSelect(opt.value)}
                                className={`option-list ${opt.value === selected ? ' text-[#12ABBF] font-medium' : 'text-[#2D3643] font-normal'
                                    }`}
                            >
                                {Icon && <Icon
                                    className={`w-5 h-5 mr-2 ${opt.value === selected ? 'stroke-[#12ABBF]' : 'stroke-[#2D3643]'
                                        }`}
                                />
                                }
                                {opt.label}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default CustomSelect;
